import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';

// Firebase web config is public by design — security is enforced via
// Firebase security rules, App Check, and server-side ID token verification.
// See: https://firebase.google.com/docs/projects/api-keys
const firebaseConfig = {
    apiKey: 'AIzaSyCT23FZenRs4XzImAK9WGbOcp0mQmXhZAw',
    authDomain: 'keeplaying-online.firebaseapp.com',
    projectId: 'keeplaying-online',
    storageBucket: 'keeplaying-online.firebasestorage.app',
    messagingSenderId: '821510631200',
    appId: '1:821510631200:web:a5bf1c75729354440ff145',
    measurementId: 'G-W6P79K89ZK',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
